import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import KittLogo from '@public/kitt-logo.svg';
import type { FC } from 'react';
type Props = Readonly<{
  className?: string;
}>;
export const KITTLogoStub: FC<Props> = t0 => {
  const $ = _c(2);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = <Image src={KittLogo} alt="KITT logo" priority={true} className={className} />;
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};